import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    FlagPostMutation,
    FlagPostMutationVariables,
} from "./__graphql-types__/FlagPostMutation.ts";

export const FLAG_POST_MUTATION: GqlOperation<
    FlagPostMutation,
    FlagPostMutationVariables
> = gqlOp(gql`
    mutation FlagPostMutation(
        $flag: String!
        $entityKey: String!
        $justification: String
    ) {
        flagEntity(
            flag: $flag
            entityKey: $entityKey
            justification: $justification
        ) {
            error {
                code
            }
        }
    }
`);
